import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Block } from '../../abstract/Block.js';
import { checkerboardCssBg } from '../svg-backgrounds/svg-backgrounds.js';
import { TRANSPARENT_PIXEL_SRC } from '../../utils/transparentPixelSrc.js';
export class FilePreview extends Block {
  constructor() {
    super();
    _defineProperty(this, "init$", _objectSpread(_objectSpread({}, this.init$), {}, {
      checkerboard: false,
      src: TRANSPARENT_PIXEL_SRC
    }));
  }
  initCallback() {
    super.initCallback();
    this.sub('checkerboard', () => {
      this.style.backgroundImage = this.hasAttribute('checkerboard') ? "url(".concat(checkerboardCssBg(), ")") : 'unset';
    });
  }
  destroyCallback() {
    super.destroyCallback();
    URL.revokeObjectURL(this._lastObjectUrl);
  }

  /** @param {HTMLImageElement} img */
  setImage(img) {
    this.$.src = img.src;
  }

  /** @param {File} imgFile */
  setImageFile(imgFile) {
    let url = URL.createObjectURL(imgFile);
    this.$.src = url;
    this._lastObjectUrl = url;
  }

  /** @param {String} url */
  setImageUrl(url) {
    this.$.src = url;
  }
  clear() {
    URL.revokeObjectURL(this._lastObjectUrl);
    this.$.src = TRANSPARENT_PIXEL_SRC;
  }
}
FilePreview.template = /* HTML */" <lr-img class=\"img-view\" ref=\"img\" set=\"@src: src; style.aa: src;\" /> ";
FilePreview.bindAttributes({
  checkerboard: 'checkerboard'
});